import { css } from 'styled-components';
import token from 'styled-token';
import { StyledButton } from '../../components/Button/Button.styles';
import { StyledIcon } from '../../components/Icon/Icon.styles';
import { FONT_TYPES } from '../../constants';
import { spaceMixin } from '../spaceMixin';
import { typographyMixin } from '../typographyMixin';

/** @class DatePickerSelectMixin */
/** @method */
export var DatePickerSelectMixin = function DatePickerSelectMixin(props) {
  return token({
    caretSize: 'DatePickerSelect.caretSize',
    iconSize: 'DatePickerSelect.Button.icon.size',
    hoverBackgroundColor: 'DatePickerSelect.Select.backgroundColor.hover',
    boxShadow: 'DatePickerSelect.boxShadow.focus',
    paddingLeft: 'DatePickerSelect.paddingLeft',
    selectFontType: 'DatePickerSelect.Select.fontType',
    selectPadding: 'DatePickerSelect.Select.padding',
    selectPaddingRight: 'DatePickerSelect.Select.paddingRight',
    buttonIconRotation: 'DatePickerSelect.Button.icon.rotate',
    buttonTop: 'DatePickerSelect.Button.rotate',
    buttonRight: 'DatePickerSelect.Button.rotate'
  }, function (_ref) {
    var caretSize = _ref.caretSize,
      iconSize = _ref.iconSize,
      hoverBackgroundColor = _ref.hoverBackgroundColor,
      boxShadow = _ref.boxShadow,
      paddingLeft = _ref.paddingLeft,
      _ref$selectFontType = _ref.selectFontType,
      selectFontType = _ref$selectFontType === void 0 ? FONT_TYPES.bodyHeading : _ref$selectFontType,
      _ref$selectPadding = _ref.selectPadding,
      selectPadding = _ref$selectPadding === void 0 ? 0 : _ref$selectPadding,
      selectPaddingRight = _ref.selectPaddingRight,
      _ref$buttonIconRotati = _ref.buttonIconRotation,
      buttonIconRotation = _ref$buttonIconRotati === void 0 ? '90deg' : _ref$buttonIconRotati,
      _ref$buttonTop = _ref.buttonTop,
      buttonTop = _ref$buttonTop === void 0 ? 0 : _ref$buttonTop,
      _ref$buttonRight = _ref.buttonRight,
      buttonRight = _ref$buttonRight === void 0 ? 0 : _ref$buttonRight;
    return css(["position:relative;display:inline-block;padding-left:", ";select{appearance:none;border:none;background:none;box-shadow:none;cursor:pointer;padding:", ";padding-right:", ";", " height:", "px;line-height:", "px;&:hover{& + button{background-color:", ";}}&:focus{outline:0;& + ", "{box-shadow:", ";}}&::-ms-expand{display:none;}}", "", "{position:absolute;top:", "px;right:", "px;pointer-events:none;width:", "px;height:", "px;", "{height:", "px;width:", "px;transform:rotate(", ");}}"], paddingLeft ? paddingLeft + "px" : spaceMixin(0.5)(props), selectPadding, selectPaddingRight ? selectPaddingRight + "px" : spaceMixin('lg')(props), typographyMixin(Object.assign({
      fontType: selectFontType
    }, props)), caretSize, caretSize, hoverBackgroundColor, StyledButton, boxShadow, StyledButton, StyledButton, buttonTop, buttonRight, caretSize, caretSize, StyledIcon, iconSize, iconSize, buttonIconRotation);
  })(props);
};